import { Observable } from 'rxjs';
import { Socket } from '../socket-io/socket-io.service';
import { IdVerificationEvents } from './id-verification-events.enum';

export class IdVerificationSocket extends Socket {
  joinVerificationRoom(verificationId: number) {
    this.ioSocket.emit('joinVerificationRoom', verificationId);
  }

  leaveVerificationRoom(verificationId: number) {
    this.ioSocket.emit('leaveVerificationRoom', verificationId);
  }

  onVerificationUpdated(): Observable<any> {
    return this.fromEvent<any>( // TODO: add - IdVerificationDto
      IdVerificationEvents.VERIFICATION_UPDATED,
    );
  }
}